/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { SubPage, Copy, BodyCopy, CTAs, Button, displayModal, displayErrorMessage } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './approvemodal_styles';

/* ========== ~~~~~~~~~~ CANCEL IMPORT POPUP~~~~~~~~~~ ========== */
const ApproveModal = props => {
    const { handleApprove, handleCancel} = props
    const [isProcessing, setIsProcessing ] = useState(false)

    return (
        <SubPage name={`approvepopup`}  klass={props.classes.approvepopup} >
            <Copy name={`approvepopup`}>
                <BodyCopy>
                    <p>Are you sure you want to generate</p>
                    <p>a new API key?</p>
                </BodyCopy>

            </Copy>
            <Copy name={`approvePopupContent`}>
                <BodyCopy name={`content`}>The current API key is still valid. If you generate a new key, it will override the current one.</BodyCopy>
            </Copy>
            <CTAs name={`ctas`} >
                <Button type={`action`} handleClick={handleCancel} variant={`normal`} name={`cancel`} text={`Cancel`} />
                <Button type={'action'} handleClick={() => { setIsProcessing(true); handleApprove(); }} variant={`action`} name={`approve`} text={`Generate New API key`} processing={isProcessing} processingText={'Generating...'} />
            </CTAs>
        </SubPage>
    );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ApproveModal);
